<template lang="pug">
.parcelleInfos 
  Graph.mt-2(
    :datas="datas",
    :graph-title="graphTitle",
    :graph-unit="graphUnit",
    v-if="datas.length > 0",
    :enableLogScale="enableLogScale",
    :enableScientificNumber="enableScientificNumber",
    :maxValue="maxValue",
    :seuil1="seuil1",
    :seuil2="seuil2"
  )
</template>


<script>
import _ from "lodash";
import Graph from "./Graph";

export default {
  name: "ParcelleInfos",
  components: {
    Graph,
  },
  props: ["infos"],
  computed: {
    title() {
      return _.get(this.infos, "title");
    },
    mesures() {
      const saveDatas = _.get(this.infos, "datas");
      return saveDatas ? JSON.parse(saveDatas) : {};
    },
    datas() {
      const datas = [];
      _.each(this.mesures, (data, index) => {
        datas.push([index, data]);
      });
      return datas;
    },
    graphTitle() {
      return _.get(this.infos, "graphTitle", "");
    },
    enableLogScale() {
      return _.get(this.infos, "enableLogScale");
    },
    enableScientificNumber() {
      return _.get(this.infos, "enableScientificNumber");
    },
    maxValue() {
      return _.get(this.infos, "maxValue");
    },
    seuil1() {
      return _.get(this.infos, "seuil1");
    },
    seuil2() {
      return _.get(this.infos, "seuil2");
    },
    graphUnit() {
      return _.get(this.infos, "graphUnit", "");
    },
  },
};
</script>
<style lang="stylus" scoped></style>

